import React from 'react';

import { 
  Container,
  Spinner,
} from "react-bootstrap-v5";

import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';


const ViewLayout = React.forwardRef((props, ref) => {
  
  return <BlockUi 
    className={!props.renderChildren ? 'custom-block-ui' : ''} 
    tag={'div'} 
    keepInView 
    blocking={props.isBlocking}
    renderChildren={props.renderChildren} 
    loader={<Spinner animation="border" />}
  >
    <div className={'view-layout'}>
      <div className={'sections'}>
        {props.topSection && <div className={'custom-top-section shadow-sm'}
          style={{ 
            top: 65 + 'px',
            zIndex: '2'
          }}
        >
          <Container className={'py-8'}>{props.topSection}</Container>
        </div>}

        <div className={'bg-white ps-5 pe-5 container'}>
          {props.actionSection && <div className={'custom-action-section'}>
            <Container className={'pb-3 px-5'}>{props.actionSection}</Container>
          </div>}

          <div className={'bg-color ps-5 pe-5 pt-5'}>
            {props.statusSection && <div className={'custom-status-section'}>
              <Container className={'pt-5 pb-5 px-0'}>{props.statusSection}</Container>
            </div>}

            <div className={'bg-white ps-5 pe-5'}>
              {props.toolbarSection && <div className={'custom-toolbar-section'}>
                <Container className={'pt-5 pb-0 ps-5 pe-5'}>{props.toolbarSection}</Container>
              </div>}

              {props.tableSection && <div className={'custom-table-section'}>
                <Container className={'pt-5 pb-5 ps-5 pe-5'}>{props.tableSection}</Container>
              </div>}
            </div>

            {props.paginationSection && <div className={'custom-pagination-section bg-color'}>
              <Container className={'pt-5 pb-5 ps-5 pe-5'}>{props.paginationSection}</Container>
            </div>}
          </div>
        </div>
      </div>
    </div>
  </BlockUi>
});

export default ViewLayout;